module.exports = __webpack_public_path__ + "img/thumb_36.a1abbded.jpg";